<mat-card class="cur-card">
  <mat-card-header>
    <mat-card-title>業務種別</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="tw-flex tw-flex-row tw-flex-wrap tw-justify-between">
      <!-- 入金／返金／振替（ラジオボタン）-->
      <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center ">
        <!-- <mat-radio-group name="registType" color="warn" -->
        <mat-radio-group name="registType" color="warn" (change)="onChangeRadio($event.value)"
          class="search-condition-radio-frame" [(ngModel)]="registType"
          style="position: relative;border: solid 1px rgba(117, 62, 62, 0.12); border-radius: 5px; padding-right: 1em;">
          <mat-label
            style="margin-left: 5px;padding-right: 3px;padding-left: 3px; position: absolute; top: -9px; font-size: 11px; color: rgba(0,0,0,0.6); background-color: white;">
            登録種別</mat-label>
          <mat-radio-button class="radio-button-margin" *ngFor="let type of registTypeList" [value]="type.value"
            [disabled]="getDisabled(type.value)"
            style="margin-bottom: 10px!important; margin-top: 10px;">{{type.viewValue}}</mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border">
        <mat-card-actions class="btn_area_right" style="margin-bottom: 0px!important;">
          <button type="button" mat-raised-button color="primary" class="btn" (click)="onClickRcvmnyInfo()"
            [disabled]="getDisabledButton('rcvmnyInfo')">入金情報</button>
          <button type="button" mat-raised-button color="primary" class="btn" (click)="onClickRpaytoCfrmPostCard()"
            [disabled]="getDisabledButton('postCard')">返金先確認はがき発行</button>
          <button type="button" mat-raised-button color="primary" class="btn" (click)="onClickReset()"
            [disabled]="getDisabledButton('reset')">承認依頼リセット</button>
          <button type="button" mat-raised-button color="primary" class="btn" (click)="returnPage()">戻る</button>
        </mat-card-actions>
      </div>
    </div>
  </mat-card-content>
</mat-card>